// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","AnnouncementContent":"AnnouncementContent-tu9qdjh7yz19kvucx1xkj7nmvv1gf3t9x3mm9n2fg2ymu8gmswakrxzw8ayfcxx8hzuk4ws7f67g9azmuc75zk3ketx4z7zcyjtxff","loading":"loading-2cd2ucyb2nexyv2utzejutcjzrfkkede6mwzdsxnumjnpj9pnfnuhahfvd2a8wkbfm7ur3qh2j1tyafgfj2624ndx9ev5fmy3pz8tqs","pulse":"pulse-3qne546x29jypd27dj26bwxw59nx79x8htumsa4syjxtzk48m351vytytycs57t9arr8x24zycccng738jxdd542p2tjwg8hsp91qps"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Announcement/AnnouncementView.module.scss
// module id = 1694
// module chunks = 0